import { errorlog } from '@/libs/error-logs';
import { toast_error } from '@/libs/toast-wrappers';

import { GET } from './base/index';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

type ICDCode = { code: string; description: string };
type ResponseICD10Codes = { all: ICDCode[]; suggested: ICDCode[] };

export async function getSuggestedICD10Codes() {
  try {
    const { data, error } = await GET<StandardResponse<ResponseICD10Codes>>(
      ENDPOINTS.ICD10_CODE_SUGGESTION
    );
    if (error) {
      toast_error(JSON.stringify(error));
      return { all: [] as ICDCode[], suggested: [] as ICDCode[] } as ResponseICD10Codes;
    }

    return data;
  } catch (e) {
    const error = e as Error;
    errorlog(error, 'src/api/ICD10Codes', 'Error fetching Suggested ICD 10 Codes');
    toast_error(error.message);
    return Promise.reject(error);
  }
}
